import FlightPayment from './FlightPayment';

export default FlightPayment;
